import CustomTextField from "../components/CustomForms/CustomTextField/CustomTextField";
import CustomFile from "../components/CustomForms/CustomFile/CustomFile";
import CustomNumberField from "../components/CustomForms/CustomNumberField/CustomNumberField.jsx";
import CustomCheckbox from "../components/CustomForms/CustomCheckbox/CustomCheckbox";
import CustomTimePicker from "../components/CustomForms/CustomTimePicker/CustomTimePicker";
import CustomSelect from "../components/CustomForms/CustomSelect/CustomSelect";
import ParentForm from "../components/CustomForms/ParentForm/ParentForm";
import CustomCheckBoxMultiple from "../components/CustomForms/CustomCheckboxMultiple/CustomCheckboxMultiple";

export default function inputHandler(type) {
	const availableInputs = {
		TextField: CustomTextField,
		File: CustomFile,
		NumberFormat: CustomNumberField,
		Checkbox: CustomCheckbox,
		KeyboardTimePicker: CustomTimePicker,
		Select: CustomSelect,
		Parent: ParentForm,
		Hidden: null,
		CheckboxMultiple: CustomCheckBoxMultiple,
	};
	return availableInputs[type];
}
